<div class="my-5">
    <sm-page-header
        [breadcrumb]="breadcrumb"
        title="settings.dacScenarios.add.title">
    </sm-page-header>
    <div class="content">
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        <div class="flex justify-end gap-2">
      <p-button [label]="'settings.dacScenarios.add.add' | translate" (click)="addDacScenarios()" />
      <p-button [label]="'settings.dacScenarios.add.reset' | translate" severity="secondary" />
    </div>
</div>